"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CachedContractsLoader = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _util = require("../util");
class CachedContractsLoader {
  constructor() {
    (0, _defineProperty2.default)(this, "api", null);
    (0, _defineProperty2.default)(this, "handler", async (state, args) => {
      if (!this.api) {
        return {
          success: false,
          code: "uninitialized",
          message: "No contracts API provided, can't load all data."
        };
      }
      let contracts = [];
      let queries = args.map((it, index) => {
        let step = state.dumbapp.steps[index];
        if ((0, _util.isContractStep)(step) && it.chainId && it.address) {
          return it;
        } else {
          return null;
        }
      });
      let result = await this.api.getAll(queries.filter(it => !!it));
      for (let it of queries) {
        if (it) {
          let contract = result.shift();
          if (contract && "network" in contract) {
            contracts.push(contract);
            continue;
          }
        }
        contracts.push(null);
      }
      return {
        success: true,
        data: contracts
      };
    });
  }
  setApi(api) {
    this.api = api;
  }
}
exports.CachedContractsLoader = CachedContractsLoader;
//# sourceMappingURL=CachedContractsLoader.js.map